import { get } from 'helpers';

export const getAllAdmins = async (page = 0, by = 10) =>
  await get(`/admins?page=${page}&by=${by}`);
